module.exports = __webpack_public_path__ + "img/img-chart-05.2ac803c9.png";